<template>
    <div class="container-fluid ">
        <Heard />
        <div class="bgImg  h-390  w-full ">
            <div class=" w-1100 h-390 mx-auto ">
                <div class="">
                    <div class="textTitle pt-80">合作案例</div>
                    <div class="w-520 my-20  leading-[1.5] text-[20px]  text-[#444444] font-normal">
                        与各大行业及政府保持长期合作，拥有丰富的行业经验，为企业、个人和 学校提供精准匹配、职业教育和就业机遇</div>
                    <!-- <el-button round size="mini" class="!bg-[#2E77FE] !text-[#fff] !mb-94 !w-130 !h-44" @click="dialogVisible = true">联系我们</el-button> -->
                    <div class="free-for-use cursor-pointer" @click="dialogVisible = true">
                        联系我们
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-center   mt-50 mb-50">
            <img src="@/assets/tab-5/tabs1(7).png" class="w-545 h-350 mr-10" />
            <img src="@/assets/tab-5/tabs1(1).png" class="w-545 h-350 mr-10" />
        </div>

        <!-- 政府行业案列 -->
        <div class="bg-[#EFFBFF] py-60">
            <div class="text-center text-[36px] font-semibold text-[#222222]">政府行业案例</div>
            <div class="flex justify-center mt-60">
                <div>
                    <div class="flex  ju">
                        <div class="w-390 h-180  mr-10">
                            <img src="@/assets/tab-5/tabs1(2).png" class="w-390 h-180" />
                        </div>
                        <div class="w-410 h180 ">
                            <img src="@/assets/tab-5/tabs1(3).png" class="w-390 h-180" />
                        </div>
                    </div>
                    <div class="flex mt-10">
                        <div class=" mr-10">
                            <img src="@/assets/tab-5/tabs1(4).png" class="w-445 h-180" />
                        </div>
                        <div class="w-335 h-180 ">
                            <img src="@/assets/tab-5/tabs1(5).png" class="w-335 h-180" />
                        </div>
                    </div>
                </div>
                <div class="w-280 h-370 ">
                    <img src="@/assets/tab-5/tabs1(6).png" class="w-390 h-370" />
                </div>
            </div>
        </div>


        <!-- 政府行业案列   -->
        <div class=" w-1100 mx-auto mt-50 mb-50">
            <div class="text-center text-[36px] font-semibold text-[#222222] mb-50">高校行业案例</div>
            <div class="flex  justify-between bg-[#F1FBF7]">
                <div class="mt-76 ml-60">
                    <div class="text-[#222222] text-[30px] font-semibold" s>
                        大学高校
                    </div>
                    <div
                        class="w-400 text-ellipsis line-clamp-1 break-all text-[#666666] text-[18px] font-normal  mt-28 leading-[2]">
                        已覆盖北京、上海、济南、杭州、成都、广州、贵阳等地 30 余所高校。
                    </div>
                </div>
                <div class="w-570 h-300">
                    <img src="@/assets/tab-5/img_college_case_01@2x.png" alt="">
                </div>
            </div>
            <div class="flex justify-between bg-[#EFFBFF] mt-10">
                <div class="w-570 h-300">
                    <img src="@/assets/tab-5/img_college_case_02@2x.png" alt="">
                </div>
                <div class="mt-36 ml-0">
                    <div class="text-[#222222] text-[30px] font-semibold" s>
                        校园招聘
                    </div>
                    <div
                        class="w-400 text-ellipsis line-clamp-1 break-all text-[#666666] text-[18px] font-normal  mt-28 mr-100 leading-[2]">
                        AI面试官 7x24
                        小时自动邀约、自动面试、自动评估，尤其适合大规模校园招聘、蓝领招聘、白领初阶岗位招聘。这些优势使得AI面试成为校园招聘中一个有效的工具，能够帮助企业快速筛选出合适的候选人。
                    </div>
                </div>
            </div>
            <div class="flex justify-between mt-10 bg-[#F1FBF7]">
                <div class="mt-36 ml-60">
                    <div class="text-[#222222] text-[30px] font-semibold" s>
                        大学城社区
                    </div>
                    <div
                        class="w-400 text-ellipsis line-clamp-1 break-all text-[#666666] text-[18px] font-normal  mt-28 leading-[2]">
                        区别于传统单一的就业咨询问答，提供全流程就业指导服务，包括职业规划、简历、求职等；全职位AI面试体验，AI岗位匹配一键投递，更多职位，更多选择；结合可移动专属就业舱，打造智能化就业区域。
                    </div>
                </div>
                <div class="w-570 h-300 ">
                    <img src="@/assets/tab-5/img_college_case_03@2x.png" alt="">
                </div>
            </div>
        </div>

        <Footer />


        <!-- 联系我们窗口 -->
        <el-dialog class="mtDialog" :visible.sync="dialogVisible" width="600px" :before-close="handleClose"
            :show-close="false">
            <div class="flex items-center pt-30 justify-between">
                <div class="text-[16px]  text-[#000000] font-semibold ">联系我们</div>
                <img src="@/assets/tab-4/btn_close@2x.png" alt="" class="w-20 h-20 " @click="dialogVisible = false">
            </div>
            <div class="flex justify-between pb-20 mt-30">
                <div class="flex justify-between w-full">
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-100 rounded-[10px]">
                        <img src="@/assets/tab-4/icon_phone@2x.png" alt="" class="w-25 h-25">
                        <div class="mt-13 text-[#222222] text-[14px] font-semibold">合作咨询电话</div>
                        <div class="mt-13 text-[#666666] text-[18px] font-normal">15117959223</div>
                    </div>
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-20  rounded-[10px] flex ">
                        <div>
                            <img src="@/assets/tab-4/icon_scan@2x.png" alt="" class="w-25 h-25">
                            <div class="mt-13 text-[#222222] text-[14px] font-semibold">添加企业微信顾问</div>
                            <div class="mt-13 text-[#666666] text-[18px] font-normal">为您详细解答</div>
                        </div>
                        <img src="@/assets/tab-4/2.jpg" alt="" class="w-95 h-95 ml-20 ">
                    </div>
                </div>
            </div>
            <div class="bg-[#F4FCFF] pt-20 pl-21 pb-23 pr-20  rounded-[10px]  ">
                <div>
                    <img src="@/assets/tab-4/icon_scan@2x.png" alt="" class="w-25 h-25">
                    <div class="mt-13 text-[#222222] text-[14px] font-semibold">联系地址</div>
                    <div class="mt-13 text-[#666666] text-[18px] font-normal">成都市天府新区天府大道2039号天府菁蓉大厦209室</div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import Heard from "@/components/Heard.vue";
import Footer from "@/components/Footer.vue";
export default {
    // name: 'employment',
    components: {
        Heard,
        Footer
    },
    metaInfo() {
        return {
            meta: [
                { name: 'keywords', content: this.$route.meta.keywords },
                { name: 'description', content: this.$route.meta.description }
            ]
        };
    },
    data() {
        return {
            dialogVisible: false,
            texts: ' 经过“字节跳动”公司数轮严格考察测试，在保证产品的良好用户体验和日十万级并行量的要求下，“AI面试通”与“抖音”官方正式签署协议并达成合作，成为“抖音官方人工智能面试产品唯一指定合作方AI面试通”做为全网DY模拟全职位人工智能面试的高科技产品，将持续致力于 为企业和求职者做好精准工作匹配，在人工智能面试行业领域继续做好自己的领军职责，为企业和个人持续赋能。'
        }
    }
}
</script>

<style lang="less" scoped>
.free-for-use {
    width: 130px;
    height: 44px;
    line-height: 44px;
    background: #2E77FE;
    border-radius: 22px;
    color: #fff;
    text-align: center;
    margin-top: 25px;
}

.mtDialog {
    border-radius: 20px;

    ::v-deep .el-dialog {
        border-radius: 10px;
        background: linear-gradient(0deg, #FFFFFF, 90%, #D5FAFF) !important;
    }

    ::v-deep .el-dialog__header {
        padding: 0px 20px !important;
    }

    ::v-deep .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

}

.bgImg {

    background: url(~@/assets/tab-5/header_bg_05@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
}

.bgs {
    background: url(~@/assets/tab-5/img_gov_case_01@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
}

.bgs-1 {
    background: url(~@/assets/tab-5/img_gov_case_03@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;

}

.bgs-2 {
    background: url(~@/assets/tab-5/img_gov_case_02@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;

}

.bgs-3 {
    background: url(~@/assets/tab-5/img_gov_case_04@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;

}

.bgs-4 {
    background: url(~@/assets/tab-5/img_gov_case_05@2x.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;

}
</style>